import { render, staticRenderFns } from "./crudCategory.vue?vue&type=template&id=36e330e7&scoped=true&"
import script from "./crudCategory.vue?vue&type=script&lang=js&"
export * from "./crudCategory.vue?vue&type=script&lang=js&"
import style0 from "./crudCategory.vue?vue&type=style&index=0&id=36e330e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e330e7",
  null
  
)

export default component.exports